import { cloneElement, isValidElement } from 'react';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { OUTAGE_REASONS } from '../../constants/outageReasons.constants';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const getOptions = zuoraAvailability => {
  if (zuoraAvailability.outageReason === OUTAGE_REASONS.PLANNED_OUTAGE && zuoraAvailability.outageEndTime) {
    return {
      endTime: zuoraAvailability.outageEndTime
    };
  }
  return {};
};
const ZuoraMessage = ({
  zuoraAvailability
}) => {
  const reason = zuoraAvailability.outageReason;
  if (reason === OUTAGE_REASONS.PLANNED_OUTAGE) {
    const nowTimestamp = new Date().getTime();
    if ((zuoraAvailability.outageEndTime ? zuoraAvailability.outageEndTime : 0) > nowTimestamp) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "account-and-billing-components.AppAvailability.zuora-outage-planned-with-end_jsx",
        options: getOptions(zuoraAvailability),
        elements: {
          Date: FormattedDateTime
        }
      });
    }
    return /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "account-and-billing-components.AppAvailability.zuora-outage-planned_jsx"
    });
  }
  return /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "account-and-billing-components.AppAvailability.zuora-outage-unplanned_jsx"
  });
};
const FintechOutagesZuoraTooltip = ({
  children,
  zuoraAvailability
}) => /*#__PURE__*/_jsx(Tooltip, {
  title: /*#__PURE__*/_jsx(ZuoraMessage, {
    zuoraAvailability: zuoraAvailability
  }),
  headingText: /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'account-and-billing-components.AppAvailability.zuora-outage-heading-text'
  }),
  children: /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/isValidElement(children) ? /*#__PURE__*/cloneElement(children, {
      disabled: true
    }) : children
  })
});
export default FintechOutagesZuoraTooltip;